import { BuyerLegalType, FoaPart, ProcedureType, Regulation } from "../../autogen/bff-api";

type CallInputs = {
  regulation?: Regulation | null;
  procedureType?: ProcedureType | null;
  foaPart?: FoaPart | null;
  buyerLegalType?: BuyerLegalType | null;
};

export const priorInformationCallOffered = ({ regulation, procedureType, foaPart, buyerLegalType }: CallInputs): boolean => {
  const callable = procedureType === ProcedureType.Restricted || procedureType === ProcedureType.NegotiatedWithPriorCall;
  if (!callable) return false;
  if (regulation === Regulation.Forsyningsforskriften) return true;
  return (
    regulation === Regulation.Foa &&
    foaPart === FoaPart.PartIii &&
    buyerLegalType != null &&
    buyerLegalType !== BuyerLegalType.CentralGovernment
  );
};

export const priorInformationCallProvision = (regulation: Regulation | null | undefined): string =>
  regulation === Regulation.Foa ? "FOA § 21-2 (2)" : "forsyningsforskriften § 17-2 (2)";
